var Backbone, FAQAutoCompleteItemView, FAQAutoCompleteView, FAQAutoSuggestionListView, FAQSearchModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

FAQSearchModel = require('../models/search');

FAQAutoCompleteItemView = require('./autocompleteItem');

Backbone = require('backbone');

Backbone.$ = $;

FAQAutoSuggestionListView = require('./autosuggestionlist');

FAQAutoCompleteView = (function(superClass) {
  extend(FAQAutoCompleteView, superClass);

  function FAQAutoCompleteView() {
    return FAQAutoCompleteView.__super__.constructor.apply(this, arguments);
  }

  FAQAutoCompleteView.prototype.tagName = "ul";

  FAQAutoCompleteView.prototype.className = "autocomplete";

  FAQAutoCompleteView.prototype.initialize = function(options) {
    this.options = options || {};
    this.wait = 500;
    this.searchModel = new FAQSearchModel();
    this.container = this.options.container;
    this.input = $("#searchFormInput");
    this.input.focus();
    this.numberOfSiblings = 1;
    return this.currentText = null;
  };

  FAQAutoCompleteView.prototype.render = function() {
    this.keyup = _.debounce(this.keyup, this.wait);
    $('#searchContent', this.container).append(this.el);
    return this.bindEvents();
  };

  FAQAutoCompleteView.prototype.invalidate = function() {
    this.reset();
    return this.input.val('');
  };

  FAQAutoCompleteView.prototype.bindEvents = function() {
    this.input.keyup((function(_this) {
      return function(event) {
        _this.keyup(event);
        return true;
      };
    })(this));
    this.input.keydown((function(_this) {
      return function(event) {
        _this.keydown(event);
        return true;
      };
    })(this));
    $('#btn-search').on('click', (function(_this) {
      return function() {
        _this.onEnter();
        return true;
      };
    })(this));
    return $(document).on('click', (function(_this) {
      return function(event) {
        var $target, autocomplete;
        $target = $(event.target);
        autocomplete = $target.closest(".autocomplate-form");
        if (autocomplete.length === 0 && _this.$el.is(":visible")) {
          return _this.invalidate();
        }
      };
    })(this));
  };

  FAQAutoCompleteView.prototype.keydown = function(event) {
    switch (event.keyCode) {
      case 38:
        return this.move(-1);
      case 40:
        return this.move(+1);
      case 13:
        return this.onEnter();
      case 27:
        return this.invalidate();
      default:
        return true;
    }
  };

  FAQAutoCompleteView.prototype.keyup = function() {
    var keyword, ref;
    keyword = (ref = this.input.val()) != null ? ref.trim() : void 0;
    if (!this.isValid(keyword)) {
      return this.reset();
    }
    if (this.isChanged(keyword)) {
      return this.getItems(keyword);
    }
    return true;
  };

  FAQAutoCompleteView.prototype.move = function(position) {
    var current, index, siblings;
    current = this.$el.children(".active");
    siblings = this.$el.children(".siblings");
    if ((current != null ? current.length : void 0) > 0 && (siblings != null ? siblings.length : void 0) > 0 && (position != null)) {
      index = (Number(current.attr("index")) + position + this.numberOfSiblings) % this.numberOfSiblings;
      if ((siblings.eq(index).length)) {
        current.removeClass("active");
        siblings.eq(index).addClass("active");
        return false;
      }
    }
    if ((siblings != null ? siblings.length : void 0) > 0) {
      if (current != null) {
        current.removeClass("active");
      }
      siblings.eq(0).addClass("active");
    }
    return false;
  };

  FAQAutoCompleteView.prototype.onEnter = function() {
    var activeLnk, href, keyword, ref;
    activeLnk = this.$el.children(".active");
    if ((activeLnk != null ? activeLnk.length : void 0) > 0) {
      href = $('a', activeLnk).attr('href');
      if ((href != null ? href.length : void 0) > 0) {
        Backbone.history.navigate("" + href, {
          trigger: true,
          replace: true
        });
      }
    } else {
      keyword = (ref = this.input.val()) != null ? ref.trim() : void 0;
      if (this.isValid(keyword)) {
        href = encodeURIComponent(keyword);
        href = "" + FAQAutoSuggestionListView.VIEWNAME + window.ID_seperator + href;
        Backbone.history.navigate("" + href, {
          trigger: true,
          replace: true
        });
      }
    }
    return false;
  };

  FAQAutoCompleteView.prototype.reset = function() {
    this.currentText = null;
    this.numberOfSiblings = 1;
    this.hide();
    return false;
  };

  FAQAutoCompleteView.prototype.isChanged = function(keyword) {
    return (this.currentText === null) || (this.currentText !== keyword);
  };

  FAQAutoCompleteView.prototype.isValid = function(keyword) {
    return (keyword != null) && keyword.length > 0;
  };

  FAQAutoCompleteView.prototype.hide = function() {
    this.$el.empty();
    this.$el.hide();
    return this.container.hide();
  };

  FAQAutoCompleteView.prototype.show = function() {
    this.container.show();
    return this.$el.show();
  };

  FAQAutoCompleteView.prototype.getItems = function(keyword) {
    this.searchModel.setUrl(keyword);
    this.currentText = keyword;
    this.searchModel.fetch({
      success: (function(_this) {
        return function(model, response, options) {
          stopTimer("t_fa");
          return _this.renderItems(response);
        };
      })(this),
      error: (function(_this) {
        return function(model, xhr, options) {
          stopTimer("t_fa");
          return _this.reset();
        };
      })(this)
    });
    return startTimer("t_fa");
  };

  FAQAutoCompleteView.prototype.renderItems = function(response) {
    var ref;
    if (this.currentText === (response != null ? response.query : void 0)) {
      if ((response != null ? (ref = response.docs) != null ? ref.length : void 0 : void 0) > 0) {
        this.reset();
        this.currentText = response.query;
        this.numberOfSiblings = response.docs.length;
        this.show();
        return _.each(response.docs, (function(_this) {
          return function(item, index) {
            var autoCompleteItem, hash;
            autoCompleteItem = new FAQAutoCompleteItemView();
            hash = {
              item: item,
              keyword: _this.currentText,
              index: index
            };
            autoCompleteItem.render(hash);
            return _this.$el.append(autoCompleteItem.el);
          };
        })(this));
      } else {
        return this.reset();
      }
    }
  };

  return FAQAutoCompleteView;

})(Backbone.View);

module.exports = FAQAutoCompleteView;

//# sourceMappingURL=data:application/json;base64,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
